<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.25 1.5H11.4C12.6601 1.5 13.2902 1.5 13.7715 1.74524C14.1948 1.96095 14.539 2.30516 14.7548 2.72852C15 3.20982 15 3.83988 15 5.1V11.4C15 12.6601 15 13.2902 14.7548 13.7715C14.539 14.1948 14.1948 14.539 13.7715 14.7548C13.2902 15 12.6601 15 11.4 15H5.1C3.83988 15 3.20982 15 2.72852 14.7548C2.30516 14.539 1.96095 14.1948 1.74524 13.7715C1.5 13.2902 1.5 12.6601 1.5 11.4V8.25M5.25 9V12M11.25 7.5V12M8.25 4.5V12M0.75 3L3 0.75M3 0.75L5.25 3M3 0.75L3 5.25"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
